import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary/15 text-primary',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive/15 text-red-400',
        success: 'border-green-800/50 bg-green-900/50 text-green-400',
        danger: 'border-red-800/50 bg-red-900/50 text-red-400',
        warning: 'border-yellow-800/50 bg-yellow-900/50 text-yellow-400',
        info: 'border-primary/30 bg-primary/10 text-primary',
        neutral: 'border-border bg-secondary text-muted-foreground',
        outline: 'text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

// Shadcn-style named export
function ShadcnBadge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// Legacy bridge wrapper (default export) preserving old API
function Badge({ children, variant = 'neutral', className = '' }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)}>
      {children}
    </span>
  );
}

export default Badge;
export { ShadcnBadge as Badge2, badgeVariants };
